module.exports = __webpack_public_path__ + "fonts/Roboto-700-latin57.665db5e.woff2";